export default __webpack_public_path__ + "static/media/srisailamVisitEight.06d1f3dd.jpg";